import axios, { AxiosInstance, AxiosRequestConfig } from "axios";
import { requestInterceptor, responseInterceptor } from "./axiosInterceptor";
import qs from "qs";

export const createBaseURL: env.vue_app = {
  local: "https://ws509hbbt5.execute-api.ap-northeast-2.amazonaws.com/v1",
  development: "https://ws509hbbt5.execute-api.ap-northeast-2.amazonaws.com/v1",
  release: "https://2p3pnpn6wd.execute-api.ap-northeast-2.amazonaws.com/v1",
  master: "https://3u1e7lonr0.execute-api.ap-northeast-2.amazonaws.com/v1",
};

const AXIOS_INIT_OPTIONS: AxiosRequestConfig = {
  baseURL: createBaseURL[import.meta.env.VITE_ENV as api.types],
};

export default axios.create({
  ...AXIOS_INIT_OPTIONS,
});

export class Axios {
  protected axios: AxiosInstance;
  constructor() {
    this.axios = this.initAxios();
    requestInterceptor(this.axios);
    responseInterceptor(this.axios);
  }

  /**
   * Axios 인스턴스를 생성합니다.
   */
  private initAxios() {
    return axios.create({
      ...AXIOS_INIT_OPTIONS,
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: "brackets" });
      },
      headers: {
        "X-bypass": false, // 토큰 bypass 여부
      },
    });
  }
}
